export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append(`
    <span class="mf-title">Upcoming Events</span>
    <div class="multiFeatureContent"></div>
    <a href="/events" class="all-events-btn">View Full Calendar</a>
  `);

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      // options
      , allEventsLink: false
      , allEventsLinkText: 'View Full Calendar'
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: false
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'MORE'}
      , maxItemsVisible: 5
      , isResponsive: false
      , hasDescription: false
      , textContainer: true
      , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'date',
        2: 'title',
        3: 'image',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data){ }
  });

};

